import { useEffect } from 'react';

const TgOauthCallback = () => {
  useEffect(() => {
    const fragment = new URLSearchParams(window.location.hash.substring(1));
    const query = new URLSearchParams(window.location.search);

    const idToken = fragment.get('id_token') || query.get('id_token');
    const accessToken = fragment.get('access_token') || query.get('access_token');
    const code = query.get('code');

    const payload = idToken ? { id_token: idToken }
      : accessToken ? { access_token: accessToken }
      : code ? { code } : null;

    if (payload && window.opener) {
      window.opener.postMessage({ type: 'tg_oauth', payload }, window.location.origin);
    }
  }, []);

  return null;
};

export default TgOauthCallback;
